import FormValidationMessages from "../../../../constants/FormValidationMessages"
import ClientUrlTypesConstants from "../../../../constants/ClientUrlTypesConstants"
import ClientTypesConstants from "../../../../constants/ClientTypes"
import FormValidators from '../../../../helpers/FormValidators'

// ======== Custom validation functions ========

const accessTokenLifeTimeCustomValidation = (accessTokenLifeTime) => {
  const isValid = accessTokenLifeTime <= 3600 && accessTokenLifeTime >= 0
  const validationMessage = "Access token life time should be between 0s and 3600s"
  return  [isValid, validationMessage]
}

const clientUrlsCustomValidation = (clientUrls, clientType) => { 
  let isValid = true
  const errors = {
    redirectUrls: {},
    logoutUrls: {},
    corsUrls: {}
  }

  if (Array.isArray(clientUrls)) {
    const redirectUrls = clientUrls?.filter(url => url.type === ClientUrlTypesConstants.REDIRECT)
    const logoutUrls = clientUrls?.filter(url => url.type === ClientUrlTypesConstants.LOGOUT)
    const corsUrls = clientUrls?.filter(url => url.type === ClientUrlTypesConstants.CORS)

    if (redirectUrls?.length === 0) {
      errors.redirectUrls.mainErrorMessage = FormValidationMessages.ATLEAST_ONE_URL_REQUIRED
      isValid = false
    }
    if (logoutUrls?.length === 0) {
      errors.logoutUrls.mainErrorMessage = FormValidationMessages.ATLEAST_ONE_URL_REQUIRED
      isValid = false
    }
    if (clientType === ClientTypesConstants.SPA && corsUrls?.length === 0) {
      errors.corsUrls.mainErrorMessage = FormValidationMessages.ATLEAST_ONE_URL_REQUIRED
      isValid = false
    }

    clientUrls?.forEach(url => {
      errors.redirectUrls.inputErrors = []
      errors.logoutUrls.inputErrors = []
      errors.corsUrls.inputErrors = []

      const isRequiredError = FormValidators.isNullOrEmpty(url.value) ? FormValidationMessages.REQUIRED : null
      const isInvalidUrlError = clientType !== ClientTypesConstants.MOBILE && FormValidators.isInvalidUrl(url.value) ? FormValidationMessages.INVALID_URL : null

      if (isRequiredError || isInvalidUrlError) {
        isValid = false
        switch (url.type) {
          case ClientUrlTypesConstants.REDIRECT:
            errors.redirectUrls.inputErrors.push({ inputId: url.inputId, inputErrorMessage: isRequiredError})
            errors.redirectUrls.inputErrors.push({ inputId: url.inputId, inputErrorMessage: isInvalidUrlError})
            break
          case ClientUrlTypesConstants.LOGOUT:
            errors.logoutUrls.inputErrors.push({ inputId: url.inputId, inputErrorMessage: isRequiredError})
            errors.logoutUrls.inputErrors.push({ inputId: url.inputId, inputErrorMessage: isInvalidUrlError})
            break
          case ClientUrlTypesConstants.CORS:
            errors.corsUrls.inputErrors.push({ inputId: url.inputId, inputErrorMessage: isRequiredError})
            errors.corsUrls.inputErrors.push({ inputId: url.inputId, inputErrorMessage: isInvalidUrlError})
            break
          default:
            break
        }
      }
    })
  }
  
  return  [isValid, errors]
}


// =========== Validation configs ===========

// WEB
export const validationConfigWeb = [
  {
    key: "accessTokenLifeTime",
    rules: {
      isRequired: true,
      customValidation: {
        func: accessTokenLifeTimeCustomValidation
      }
    }
  },
  {
    key: "accessTokenType",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "clientUrls",
    rules: {
      customValidation: {
        func: (value) => clientUrlsCustomValidation(value, ClientTypesConstants.WEB)
      }
    }
  },
]

// SERVER
export const validationConfigServer = [
  {
    key: "accessTokenLifeTime",
    rules: {
      isRequired: true,
      customValidation: {
        func: accessTokenLifeTimeCustomValidation
      }
    }
  },
  {
    key: "accessTokenType",
    rules: {
      isRequired: true,
    }
  },
]

// SPA
export const validationConfigSpa = [
  {
    key: "accessTokenLifeTime",
    rules: {
      isRequired: true,
      customValidation: {
        func: accessTokenLifeTimeCustomValidation
      }
    }
  },
  {
    key: "accessTokenType",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "clientUrls",
    rules: {
      customValidation: {
        func: (value) => clientUrlsCustomValidation(value, ClientTypesConstants.SPA)
      }
    }
  },
]

// MOBILE
export const validationConfigMobile = [
  {
    key: "accessTokenLifeTime",
    rules: {
      isRequired: true,
      customValidation: {
        func: accessTokenLifeTimeCustomValidation
      }
    }
  },
  {
    key: "accessTokenType",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "clientUrls",
    rules: {
      customValidation: {
        func: (value) => clientUrlsCustomValidation(value, ClientTypesConstants.MOBILE)
      }
    }
  },
]